import { useSelector } from "react-redux";
import { selectCurrentToken, selectCurrentUserDisplayname } from "../../auth/authSlice";
import { useTranslation } from "react-i18next";
import Loading from "components/commons/Loading";
import PageLayout from "components/layout/PageLayout";
import UserCardLayout from "components/layout/UserCardLayout";
import { useGetUserInfoQuery } from "./api/userInfoApiSlice";
import { NavLink } from "react-router-dom";

const UserInfo = () => {

    const [t, i18n] = useTranslation(["global"])

    const {
        data: userInfo,
        isLoading,
        isSuccess,
        isError,
        error
    } = useGetUserInfoQuery()

    const token = useSelector(selectCurrentToken)
    const userDisplayname = useSelector(selectCurrentUserDisplayname)

    let content;
    if (isLoading) {
        content = <Loading />
    } else if (isSuccess) {
        content = (

            <section className="userInfo">

                <div className="col mb-2 text-end">
                    <NavLink to={{ pathname: "/dashboard/userInfo/edit" }} className={`btn btn-light me-1`} ><i className="fa-solid fa-pen"></i> {t("action.edit")}</NavLink>
                </div>

                <UserCardLayout user={userInfo.user} employment={userInfo.employments[0]} />

                {/* <h3><i className="fas fa-user"></i> {userDisplayname}</h3>
                <br />
                <div className="row mb-2">
                    <div className="col">

                        <p>
                            <span className="text-warning"><i className="fa-solid fa-user-lock"></i> Username <br /> </span>
                            {userInfo.user.username}
                        </p>
                        <p>
                            <span className="text-warning"><i className="fa-solid fa-envelope"></i> Email <br /> </span>
                            {userInfo.user.email}
                        </p>

                    </div>

                </div>
                <hr />
                <div className="row mb-2">
                    <h3>Engagements ( {userInfo.employments.length} )</h3>
                    <div className="col">
                        <ul>
                            {userInfo.employments.map((employment, i) => {
                                return <li key={i}><span className="badge " style={{ backgroundColor: employment.role.backgroundColor, color: employment.role.textColor, padding: "10px" }}>{employment.role.name}</span> of <b>{employment.company.name}</b> company</li>
                            })}
                        </ul>
                    </div>

                </div> <hr />*/}

                <div className="row mb-2">
                    <h3>System Info:</h3>
                    <div className="col">
                        <div className="card bg-dark opacity-50">

                            <div className="card-body">
                                <h5 className="card-title">GUID</h5>
                                {userInfo.user.guid}
                            </div>
                        </div>

                        <div className="card bg-dark opacity-50">

                            <div className="card-body">
                                <h5 className="card-title">JWT</h5>
                                {token}
                            </div>
                        </div>
                    </div>

                </div>

            </section>
        )
    } else if (isError) {
        content = <p>{JSON.stringify(error)}</p>;
    }

    return <PageLayout
        pageTitle={t("menu.my_profile")}
        bodyContent={content}
    />
}
export default UserInfo